export default __webpack_public_path__ + "static/media/Outsite.220477a3.png";